import { Component, OnInit,Renderer, ElementRef, ViewChild } from '@angular/core';
import {Directive, Output, EventEmitter} from '@angular/core';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { NotificationsService } from 'angular2-notifications';
import { DataService, MIN_CHAR_SEARCH_LENGTH, AuthService, DateUtility, INVALID_EMAIL } from '../shared';
import {ProviderService} from "../provider-management/provider-management.service";
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from "rxjs/Observable";
import { CanComponentDeactivate, CanDeactivateGuardService } from "../shared/modals/modal-popup/can-deactivate-gaurd.service";
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';

@Component({
  selector: 'app-admin-provider-details',
  templateUrl: './admin-provider-details.component.html',
  styleUrls: ['./admin-provider-details.component.scss']
})
export class AdminProviderDetailsComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('headerText') headerText:ElementRef;
  @ViewChild('fileInput') fileInput:ElementRef;
  @ViewChild('emailMsg') emailMsg:ElementRef;
  @ViewChild('emailField') emailField: ElementRef;
  today: Date = new Date();
  minESDate:NgbDateStruct;
  tabIndex:any="0";
  minRDDate: NgbDateStruct;
  userActionNotificationsMap: any;
  maxRDDate: NgbDateStruct;
  isResetDisable:Boolean = true;
  errorReasonCd: Boolean = false;
  initialData:Boolean;
  validEmail = true;
  editData:any = {
    "id":"",
    "recordVersion":"",
    "providerName": "",
    "primaryContactFirstName": "",
    "primaryContactLastName": "",
    "primaryAddrLine1": "",
    "primaryAddrLine2": "",
    "primaryCity": "",
    "primaryState": "",
    "primaryZip5": "",
    "primaryZip4": "",
    "primaryPhoneNumber": "",
    "primaryFaxNumber": "",
    "primaryEmail": "",
    "providerBeginDt": "",
    "providerEndDt": null
};
editDataPrev: any;
errorEmailField: string = null;
isChangeDetected: boolean;
  constructor(
    private notificationService: NotificationsService,
    public dataService: DataService,
    private dateUtil: DateUtility,
    private providerService: ProviderService,
    private router: Router,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService
  ) {
    if(this.dataService.getSharedDataObject().get("ADPSH") == undefined){
      this.router.navigate(['/admin/provider-management']);
    }
  }
  ngOnInit() {
    this.dataService.globalAccess = true;
    this.minESDate = {
      month: this.today.getMonth()+1,
      day: this.today.getDate(),
      year: this.today.getFullYear()
    };
    this.maxRDDate = {
      month: this.today.getMonth() + 1,
      day: this.today.getDate(),
      year: this.today.getFullYear()
    };
    if(this.dataService.getSharedDataObject().get("provider")== undefined){
      this.initialData = true;
      this.editDataPrev = Object.assign({}, this.editData);
    }
    else{
      this.editData.recordVersion = this.dataService.getSharedDataObject().get("provider").recordVersion;
      this.editData.id = this.dataService.getSharedDataObject().get("provider").id;
      this.editData.providerName = this.dataService.getSharedDataObject().get("provider").providerName;
      this.editData.primaryContactFirstName = this.dataService.getSharedDataObject().get("provider").primaryContactFirstName;
      this.editData.primaryContactLastName = this.dataService.getSharedDataObject().get("provider").primaryContactLastName;
      this.editData.primaryAddrLine1 = this.dataService.getSharedDataObject().get("provider").primaryAddrLine1;
      this.editData.primaryAddrLine2 = this.dataService.getSharedDataObject().get("provider").primaryAddrLine2;
      this.editData.primaryCity = this.dataService.getSharedDataObject().get("provider").primaryCity;
      this.editData.primaryState = this.dataService.getSharedDataObject().get("provider").primaryState;
      if(this.dataService.getSharedDataObject().get("provider").primaryZip4 !== ""){
        this.editData.primaryZip5 = this.dataService.getSharedDataObject().get("provider").primaryZip5  + this.dataService.getSharedDataObject().get("provider").primaryZip4;
      }
      else{
        this.editData.primaryZip5 = this.dataService.getSharedDataObject().get("provider").primaryZip5;
      }
      this.editData.primaryPhoneNumber = this.dataService.getSharedDataObject().get("provider").primaryPhoneNumber;
      this.editData.primaryFaxNumber = this.dataService.getSharedDataObject().get("provider").primaryFaxNumber;
      this.editData.primaryEmail = this.dataService.getSharedDataObject().get("provider").primaryEmail;
      this.editData.providerBeginDt = this.dataService.getSharedDataObject().get("provider").providerBeginDt;
      this.editData.providerEndDt = this.dataService.getSharedDataObject().get("provider").providerEndDt;
      this.initialData = false;
      this.editData.providerBeginDt= this.dateUtil.convertDateFromServer(this.editData.providerBeginDt);
      this.editData.providerEndDt = this.dateUtil.convertDateFromServer(this.editData.providerEndDt);
      this.editDataPrev = Object.assign({}, this.editData);
    }
  }
  focusing(event){
    if(!event.shiftKey && event.keyCode==9){
      event.preventDefault();
    setTimeout(() => this.headerText.nativeElement.focus(), 0);
    this.headerText.nativeElement.click();
    }
  }
  restrictSpaceSpecial(event){
   if(!(/[a-zA-Z0-9-' ]/.test(event.key))){
    event.returnValue = false;
    return;
   }
    event.returnValue = true;
  }
  restrictSpecial(event){
    if(!(/[a-zA-Z0-9 ]/.test(event.key))){
      event.returnValue = false;
      return;
     }
      event.returnValue = true;
  }
  restrictSpecialTags(event){
    if((/[<>{}]/.test(event.key))){
      event.returnValue = false;
      return;
     }
      event.returnValue = true;
  }
  
  replaceSpecial(){
    this.editData.primaryContactFirstName = this.editData.primaryContactFirstName.toString().replace(/[^a-zA-Z 0-9-'\n\r]+/g, '');
    this.editData.primaryContactLastName = this.editData.primaryContactLastName.toString().replace(/[^a-zA-Z 0-9-'\n\r]+/g, '');
  }
  restrict(event){
    if(!((event.shiftKey === false) && (event.keyCode >= 48) && (event.keyCode <= 57) || (event.keyCode == 9) || (event.keyCode >= 96) && (event.keyCode <= 105) || (event.keyCode>=37) && (event.keyCode<=40) || (event.keyCode == 32) || (event.keyCode ==8))){
      event.returnValue = false;
      return;
   }
    event.returnValue = true;
  }
  dataChanges(){
    this.isResetDisable=false;
    this.tabIndex = "-1";
    this.isChangeDetected=true;
    if(this.editData.primaryZip5.length >= 9 || this.editData.primaryZip5.length ==5){
      this.editData.primaryZip5 = this.editData.primaryZip5;
    }
    else{
      this.editData.primaryZip5 = "";
    }
  }
  getFromDate() {
    this.minESDate = {
      month: this.editData.providerBeginDt["month"],
      day: this.editData.providerBeginDt["day"],
      year: this.editData.providerBeginDt["year"]
    }
  }
  reset(){
    if(this.initialData){
      this.editData ={};
    }
    else{
      this.editData.providerName = this.dataService.getSharedDataObject().get("provider").providerName;
      this.editData.primaryContactFirstName = this.dataService.getSharedDataObject().get("provider").primaryContactFirstName;
      this.editData.primaryContactLastName = this.dataService.getSharedDataObject().get("provider").primaryContactLastName;
      this.editData.primaryAddrLine1 = this.dataService.getSharedDataObject().get("provider").primaryAddrLine1;
      this.editData.primaryAddrLine2 = this.dataService.getSharedDataObject().get("provider").primaryAddrLine2;
      this.editData.primaryCity = this.dataService.getSharedDataObject().get("provider").primaryCity;
      this.editData.primaryState = this.dataService.getSharedDataObject().get("provider").primaryState;
      if(this.dataService.getSharedDataObject().get("provider").primaryZip4 !== ""){
        this.editData.primaryZip5 = this.dataService.getSharedDataObject().get("provider").primaryZip5 + this.dataService.getSharedDataObject().get("provider").primaryZip4;
      }
      else{
        this.editData.primaryZip5 = this.dataService.getSharedDataObject().get("provider").primaryZip5;
      }
      this.editData.primaryPhoneNumber = this.dataService.getSharedDataObject().get("provider").primaryPhoneNumber;
      this.editData.primaryFaxNumber = this.dataService.getSharedDataObject().get("provider").primaryFaxNumber;
      this.editData.primaryEmail = this.dataService.getSharedDataObject().get("provider").primaryEmail;
      this.editData.providerBeginDt = this.dataService.getSharedDataObject().get("provider").providerBeginDt;
      this.editData.providerEndDt = this.dataService.getSharedDataObject().get("provider").providerEndDt;
      this.editData.providerBeginDt= this.dateUtil.convertDateFromServer(this.editData.providerBeginDt);
      this.editData.providerEndDt = this.dateUtil.convertDateFromServer(this.editData.providerEndDt);
    }
  }
  validateEmail(event){
    const regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if(this.editData.primaryEmail !== null && this.editData.primaryEmail !== undefined) {
      if(!regExp.test(String(this.editData.primaryEmail).toLowerCase())){
        this.errorEmailField = INVALID_EMAIL;
        this.emailField.nativeElement.classList.remove("ng-valid");
        this.emailField.nativeElement.classList.add("ng-invalid");
        this.emailMsg.nativeElement.classList.add("d-block");
        this.emailMsg.nativeElement.classList.remove("d-none");
        this.validEmail = false;
        return false;
      }
      else{
        this.emailField.nativeElement.classList.remove("ng-invalid");
        this.emailField.nativeElement.classList.add("ng-valid");
        this.errorEmailField = null;
        this.emailMsg.nativeElement.classList.remove("d-block");
        this.emailMsg.nativeElement.classList.add("d-none");
        this.validEmail = true;
      }
    }
    this.errorEmailField = null;
    return true;
  }
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if(this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  };
  save(){
    setTimeout(() => this.fileInput.nativeElement.focus(), 0);
    this.fileInput.nativeElement.click();
    this.isChangeDetected = false;
    let token = this.dataService.getSharedDataObject().get("token");
    console.log(this.editData);
    this.editData.providerBeginDt= this.dateUtil.convertDateForServer(this.editData.providerBeginDt);
    this.editData.providerEndDt= this.dateUtil.convertDateForServer(this.editData.providerEndDt);
    if(this.editData.primaryZip5.length >= 9){
      if(this.editData.primaryZip5.length == 10){
        this.editData.primaryZip4 = this.editData.primaryZip5.slice(6,10);
      }
      else{
        this.editData.primaryZip4 = this.editData.primaryZip5.slice(5,10);
      }
      this.editData.primaryZip5 = this.editData.primaryZip5.slice(0,5);
    }
    else{
      this.editData.primaryZip4 = '';
    }
    if(this.editData.primaryZip5.length !==5 || !this.validEmail){
      // this.notificationService.error('Invalid Format for Mandatatory Fields');
      if(!this.validEmail){
        this.notificationService.error('Enter a Valid Format for Email Field');
      }
      else{
        this.notificationService.error('Enter a Valid ZipCode Field');
      }
        this.editData.providerBeginDt= this.dateUtil.convertDateFromServer(this.editData.providerBeginDt);
        this.editData.providerEndDt= this.dateUtil.convertDateFromServer( this.editData.providerEndDt);
    }
    else{
      this.providerService.saveProviderDetails(token,this.editData).subscribe((data)=>{
        console.log(data);
        if(data.id){
          this.notificationService.success('Provider Details saved successfully');
          this.editData.recordVersion = data.recordVersion;
          this.editData.id = data.id;
          this.editData.providerBeginDt= this.dateUtil.convertDateFromServer(data.providerBeginDt);
          this.editData.providerEndDt= this.dateUtil.convertDateFromServer(data.providerEndDt);
          setTimeout(() => this.headerText.nativeElement.focus(), 0);
          this.headerText.nativeElement.click();
          if(this.editData.primaryZip4 !== ""){
            this.editData.primaryZip5 = this.editData.primaryZip5  + this.editData.primaryZip4;
          }
          else{
            this.editData.primaryZip5 = this.editData.primaryZip5;
          }
          this.dataService.addValueToSharedDataMap('provider',data);
          this.modalPopupService.setChangeDetected(false);
        }
        else{
          this.notificationService.error('System Error:Please contact Help Desk');
          this.editData.providerBeginDt= this.dateUtil.convertDateFromServer(this.editData.providerBeginDt);
          this.editData.providerEndDt= this.dateUtil.convertDateFromServer(this.editData.providerEndDt);
        }
        //this.router.navigate(['admin/provider-management']);
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin-provider-details/admin-provider-details.component.ts